import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export const DetectionImageSection = () => {
  return <section className="py-20 bg-[#050505] relative overflow-hidden" data-id="element-2258">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(20,20,20,0.5)_1px,transparent_1px),linear-gradient(90deg,rgba(20,20,20,0.5)_1px,transparent_1px)] bg-[size:40px_40px] opacity-30 pointer-events-none" data-id="element-2259" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-2260">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-2261">
          {/* Forensic Frame */}
          <div className="relative p-2 border border-[#00FF00]/30 bg-[#0a0a0a]" data-id="element-2262">
            {/* Corner Markers */}
            <div className="absolute -top-1 -left-1 w-6 h-6 border-t-2 border-l-2 border-[#00FF00] z-20" data-id="element-2263" />
            <div className="absolute -top-1 -right-1 w-6 h-6 border-t-2 border-r-2 border-[#00FF00] z-20" data-id="element-2264" />
            <div className="absolute -bottom-1 -left-1 w-6 h-6 border-b-2 border-l-2 border-[#00FF00] z-20" data-id="element-2265" />
            <div className="absolute -bottom-1 -right-1 w-6 h-6 border-b-2 border-r-2 border-[#00FF00] z-20" data-id="element-2266" />

            <div className="relative overflow-hidden rounded-lg" data-id="element-2267">
              <img src="https://cdn.magicpatterns.com/uploads/a61U7X1ucT4CK3pR26ntaZ/file_0000000094d471f4ba8649e39a017110.png" alt="AI forensic analysis - Close-up of eyes with digital overlay displaying TOXICITY DETECTED with data visualization and threat assessment" className="w-full h-auto object-cover" loading="lazy" decoding="async" data-id="element-2268" />

              {/* Scanning Line Animation */}
              <div className="absolute top-0 left-0 w-full h-[2px] bg-[#00FF00] shadow-[0_0_15px_#00FF00] animate-[scan_3s_ease-in-out_infinite]" data-id="element-2269" />

              {/* HUD Overlay */}
              <div className="absolute top-4 right-4 bg-black/70 border border-[#00FF00]/50 px-3 py-1" data-id="element-2270">
                <span className="text-[#00FF00] text-xs font-mono tracking-wider" data-id="element-2271">
                  ANALYSIS ACTIVE
                </span>
              </div>
            </div>
          </div>

          {/* Glow Effect */}
          <div className="absolute -inset-4 bg-[#00FF00]/5 blur-3xl -z-10 rounded-full" data-id="element-2272" />
        </motion.div>
      </div>
    </section>;
};